module.exports = __webpack_public_path__ + "static/illustration-ppi@2x-48727980ca5890afada9d63d9948818a.png";